import {
  CalculatorSettings,
  StoredCalculator,
  calculateProjection,
  getReturns,
} from "./versatileTypes";
import Select from "src/components/Inputs/Select";
import Button from "src/components/Inputs/Button";

const Solve = ({
  settings,
  simple = false,
  updateCalculator,
}: {
  settings: StoredCalculator;
  simple?: boolean;
  updateCalculator: any;
}) => {
  const solveOptions = [
    { id: "return", name: "Rate of Return" },
    { id: "presentValue", name: "Present Value" },
    { id: "payment", name: "Payment" },
  ];

  const updateSettings = (category: keyof CalculatorSettings, data: any) => {
    updateCalculator({
      ...settings,
      [category]: {
        ...settings[category],
        ...data,
      },
    });
  };

  const solve = () => {
    if (settings.solve.field === "return" || !settings.solve.field) {
      handleSolveRateOfReturn();
    } else if (settings.solve.field === "presentValue") {
      handleSolvePresentValue();
    } else if (settings.solve.field === "payment") {
      handleSolvePayments();
    }
  };
  const handleSolvePayments = () => {
    const targetEndingBalance = settings.user.endValue || 0;
    let low = -10000000;
    let high = 1000000;
    let mid = 0;
    let iteration = 0;
    const maxIterations = 10000;
    const tolerance = 0.001;

    const testSettings = structuredClone(settings);
    testSettings.payment.type = "simple";

    const returnsMemo = getReturns(settings);
    while (iteration < maxIterations) {
      mid = (low + high) / 2;
      testSettings.payment.amount = mid;

      const calculations = calculateProjection(testSettings, returnsMemo);

      const lastRow = calculations[calculations.length - 1];

      if (Math.abs(lastRow.realBalance - targetEndingBalance) < tolerance) {
        break;
      }

      if (lastRow.realBalance < targetEndingBalance) {
        high = mid;
      } else {
        low = mid;
      }

      iteration++;
    }
    updateSettings("payment", { amount: mid, type: "simple" });
  };

  const handleSolveRateOfReturn = () => {
    const targetEndingBalance = settings.user.endValue || 0;
    let low = 0;
    let high = 100;
    let mid = 0;
    let iteration = 0;
    const maxIterations = 10000;
    const tolerance = 0.001;

    const testSettings = structuredClone(settings);
    testSettings.returns.returnType = "simple";

    while (iteration < maxIterations) {
      const returnsMemo = (_: number) => mid;
      mid = (low + high) / 2;
      testSettings.returns.rateOfReturn = mid;

      const calculations = calculateProjection(testSettings, returnsMemo);

      const lastRow = calculations[calculations.length - 1];

      if (Math.abs(lastRow.realBalance - targetEndingBalance) < tolerance) {
        break;
      }

      if (lastRow.realBalance > targetEndingBalance) {
        high = mid;
      } else {
        low = mid;
      }

      iteration++;
    }

    updateSettings("returns", { rateOfReturn: mid, type: "simple" });
  };

  const handleSolvePresentValue = () => {
    const targetEndingBalance = settings.user.endValue || 0;
    let low = 0;
    let high = 100000000;
    let mid = 0;
    let iteration = 0;
    const maxIterations = 100000;
    const tolerance = 0.001;

    const testSettings = structuredClone(settings);

    const returnsMemo = getReturns(settings);
    while (iteration < maxIterations) {
      mid = (low + high) / 2;
      testSettings.user.presentValue = mid;

      const calculations = calculateProjection(testSettings, returnsMemo);

      const lastRow = calculations[calculations.length - 1];

      if (Math.abs(lastRow.realBalance - targetEndingBalance) < tolerance) {
        break;
      }

      if (lastRow.realBalance > targetEndingBalance) {
        high = mid;
      } else {
        low = mid;
      }

      iteration++;
    }

    updateSettings("user", { presentValue: mid });
  };

  if (simple)
    return (
      <div className="flex gap-6 items-end">
        <div className="w-64">
          <Button type="primary" onClick={solve}>
            Solve for Rate of Return
          </Button>
        </div>
      </div>
    );
  return (
    <div className="flex gap-6 items-end">
      <div className="w-48">
        <Select
          vertical
          label="Solve for:"
          options={solveOptions}
          selected={
            solveOptions.find((o) => o.id === settings.solve.field) || {
              id: "return",
              name: "Rate of Return",
            }
          }
          setSelected={(option) =>
            updateSettings("solve", { field: option.id })
          }
        />
      </div>
      <div className="w-28">
        <Button type="primary" onClick={solve}>
          Solve
        </Button>
      </div>
    </div>
  );
};

export default Solve;
